import { t } from '@gem/modules/i18n';

import * as groupModel from 'APP/model/group/groupModel';
import { ISetChatMessagesHistoryTtlRequest } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';

import { showToast } from '../../app/app';

function handleSetChatMessagesHistoryTtlError(): void {
  showToast(t('common_somethings_wrong_error'));
}

export async function setChatMessagesHistoryTtl(
  data: ISetChatMessagesHistoryTtlRequest
): Promise<boolean> {
  const group = Entities.GroupsStore.getGroupById(data.groupId);
  if (!group) {
    return false;
  }
  const currentTtlPeriodMs = group.ttlPeriodMs;
  group.ttlPeriodMs = data.ttlPeriodMs;

  try {
    const result = await groupModel.setChatMessagesHistoryTtl(data);
    if (!result) {
      group.ttlPeriodMs = currentTtlPeriodMs;
      handleSetChatMessagesHistoryTtlError();
      return false;
    }
    return true;
  } catch {
    group.ttlPeriodMs = currentTtlPeriodMs;
    handleSetChatMessagesHistoryTtlError();
    return false;
  }
}
